import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';
import { TypeGuardError } from 'src/core/utils/switchGuard';

import { type Dimension } from './dimension';
import { type DimensionValueId } from './dimensionValues';

export type DimensionData = {
  costCenter: Map<string, { name: string }>;
  expenseCategory: Map<string, { name: string }>;
  supplier: Map<string, { name: string }>;
};

export const getOtherValuesText = (
  dimension: Dimension,
  t: TGlobalFunctionTyped,
): string => {
  switch (dimension.type) {
    case 'costCenter':
      return t('budgetByDimensions.dimensions.costCenter.otherValues');
    case 'expenseCategory':
      return t('budgetByDimensions.dimensions.expenseCategory.otherValues');
    case 'supplier':
      return t('budgetByDimensions.dimensions.supplier.otherValues');
    default:
      throw new TypeGuardError(dimension.type, 'Unknown dimension');
  }
};

export const getUnassignedValuesText = (
  dimension: Dimension,
  t: TGlobalFunctionTyped,
): string => {
  switch (dimension.type) {
    case 'costCenter':
      return t('budgetByDimensions.dimensions.costCenter.unassignedValues');
    case 'expenseCategory':
      return t(
        'budgetByDimensions.dimensions.expenseCategory.unassignedValues',
      );
    case 'supplier':
      return t('budgetByDimensions.dimensions.supplier.unassignedValues');
    default:
      throw new TypeGuardError(dimension.type, 'Unknown dimension');
  }
};

/**
 * Get the human-readable label for a dimension value
 */
export const getDimensionName = (
  dimension: Dimension,
  valueId: DimensionValueId,
  dimensionData: DimensionData,
  t: TGlobalFunctionTyped,
): string | undefined => {
  switch (valueId.type) {
    case 'specific':
      return dimensionData[dimension.type].get(valueId.value)?.name;
    case 'unassigned':
      return getUnassignedValuesText(dimension, t);
    case 'other':
      return getOtherValuesText(dimension, t);
    default:
      throw new TypeGuardError(valueId, 'Unknown DimensionValueId type');
  }
};
